import { DataService } from './dataService'

const GalleryService = {
	getGallery: async (data) => {
		return DataService.get('/admin/get_gallery_image', data)
	},
	deleteGalleryImage: async (data) => {
        return DataService.delete('/admin/delete_gallery?id=' + data.id, data)
    },
    addGalleryImage: async (data) => {
		return DataService.post('/admin/add_gallery', data)
	}
}

export default GalleryService